import { Typography, Divider, Stack, Link } from '@mui/material';

export default function CookiePolicyDe() {
  return (
    <Stack spacing={3}>
      <Typography variant="h4" fontWeight={700}>
        BRITESTAGE – Cookie-Richtlinie
      </Typography>
      <Typography variant="body2" color="text.secondary">
        <strong>Version 1.0</strong>
        <br />
        Stand: 30. April 2026
      </Typography>

      <Divider />

      <Typography variant="h5" fontWeight={600}>
        1. Verantwortliche Stelle
      </Typography>
      <Typography variant="body1">
        Verantwortlicher im Sinne der Datenschutz-Grundverordnung (DSGVO) und der ePrivacy-Richtlinie bzw. des
        nationalen Telekommunikations- und Telemedienrechts (insbesondere TTDSG in Deutschland) ist:
      </Typography>
      <Typography variant="body1">
        <strong>21Minds GmbH</strong>
        <br />
        Botnanger Str. 6
        <br />
        70193 Stuttgart
        <br />
        Deutschland
        <br />
        (&quot;BRITESTAGE&quot;, &quot;wir&quot;)
      </Typography>
      <Typography variant="body1">
        Kontakt:{' '}
        <Link href="mailto:info@britestage.com" color="primary">
          info@britestage.com
        </Link>
      </Typography>
      <Typography variant="body1">
        Diese Cookie-Richtlinie ergänzt unsere{' '}
        <Link href="/legal/privacy?lang=de" color="primary">
          Datenschutzerklärung
        </Link>
        . Dort finden Sie weitere Informationen zur Verarbeitung personenbezogener Daten, zu Ihren Betroffenenrechten
        und zu etwaigen Drittlandübermittlungen.
      </Typography>

      <Divider />

      <Typography variant="h5" fontWeight={600}>
        2. Cookies und ähnliche Technologien
      </Typography>
      <Typography variant="body1">
        Cookies sind kleine Textdateien, die beim Aufruf einer Website auf Ihrem Endgerät gespeichert werden. Zu den
        ähnlichen Technologien zählen beispielsweise Pixel, Skripte oder Speichermechanismen des Browsers (wie Local
        Storage oder Session Storage), mit denen Informationen auf Ihrem Endgerät zu vergleichbaren Zwecken gelesen oder
        geschrieben werden können.
      </Typography>
      <Typography variant="body1">
        Wir setzen sowohl Cookies als auch – soweit technisch sinnvoll – begrenzten Browserspeicher ein, um den Dienst
        bereitzustellen.
      </Typography>

      <Divider />

      <Typography variant="h5" fontWeight={600}>
        3. Aktueller Einsatz (schlanke technische Ausgestaltung)
      </Typography>
      <Typography variant="body1">
        BRITESTAGE ist technisch bewusst schlank aufgestellt. Derzeit betreiben wir auf der Plattform keine eigenen
        werblichen oder marketingbezogenen Cross-Site-Tracker und setzen im Produkt keine Analyse-Cookies von
        Drittanbietern (z. B. zur Reichweitenmessung) ein.
      </Typography>

      <Typography variant="h6" fontWeight={600}>
        3.1 Unbedingt erforderliche Cookies und Authentifizierung (Clerk)
      </Typography>
      <Typography variant="body1">
        Für die Authentifizierung und Sitzungsverwaltung nutzen wir Clerk (&quot;Clerk, Inc.&quot;). Wenn Sie sich
        anmelden oder ein Konto erstellen, setzt Clerk Cookies, die erforderlich sind, um Sie sicher angemeldet zu
        halten, Konten zu schützen und Missbrauch zu verhindern. Ohne diese Technologien kann die passwortgeschützte
        Nutzung der Plattform nicht angeboten werden.
      </Typography>
      <Typography variant="body1">
        Clerk verarbeitet Daten für uns als Auftragsverarbeiter im Sinne der DSGVO. Informationen zu Cookies und
        ähnlichen Technologien bei Clerk finden Sie in den jeweiligen Hinweisen von Clerk unter{' '}
        <Link href="https://clerk.com/legal/privacy" target="_blank" rel="noopener noreferrer" color="primary">
          clerk.com/legal/privacy
        </Link>
        .
      </Typography>
      <Typography variant="body1">
        <strong>Rechtsgrundlage:</strong> Art. 6 Abs. 1 lit. b DSGVO (Vertragserfüllung bzw. vorvertragliche Maßnahmen)
        und soweit einschlägig Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an sicherem Betrieb und
        Betrugsprävention) im Einklang mit den Vorgaben des TTDSG und der EU-Cookie-Rechtslage für technisch notwendige
        Cookies.
      </Typography>

      <Typography variant="h6" fontWeight={600}>
        3.2 Browserspeicher für grundlegende Funktionen (z. B. Sprache)
      </Typography>
      <Typography variant="body1">
        Bestimmte nicht sensible Einstellungen (z. B. die gewählte Oberflächensprache) speichern wir im Browser, etwa
        über Local Storage, damit sich die Anwendung bei wiederholten Besuchen korrekt laden kann. Dies dient nicht der
        Nachverfolgung Ihrer Aktivitäten über unzusammenhängende Websites hinweg.
      </Typography>
      <Typography variant="body1">
        <strong>Rechtsgrundlage:</strong> Art. 6 Abs. 1 lit. b DSGVO und soweit einschlägig Art. 6 Abs. 1 lit. f DSGVO
        (berechtigtes Interesse an einer nutzbaren Dienstleistung), im Rahmen der Ausnahmen für technisch notwendige
        Technologien.
      </Typography>

      <Typography variant="h6" fontWeight={600}>
        3.3 Optionale Kategorien und Ihre gespeicherten Präferenzen
      </Typography>
      <Typography variant="body1">
        Im Onboarding können Sie Präferenzen zu weiteren Kategorien (z. B. funktional, analytisch, Marketing) angeben.
        Ihre Auswahl kann in Ihrem Nutzerprofil gespeichert werden, damit wir sie respektieren können, falls wir
        optional Technologien künftig einführen.
      </Typography>
      <Typography variant="body1">
        <strong>Aktueller Produktstand:</strong> Wir setzen derzeit keine Werbe-Cookies von Drittanbietern und keine
        marketingbezogenen Cross-Site-Tracking-Technologien auf der Plattform ein. Im aktuellen Build verwenden wir
        keine Analyse-Cookies von Drittanbietern. Sollte sich dies ändern, passen wir diese Cookie-Richtlinie an und
        holen soweit gesetzlich erforderlich Ihre Einwilligung ein, bevor nicht notwendige Cookies aktiviert werden.
      </Typography>
      <Typography variant="body1">
        <strong>Rechtsgrundlage für die Speicherung Ihrer Auswahl:</strong> Art. 6 Abs. 1 lit. a DSGVO (Einwilligung),
        soweit für die jeweilige Verarbeitung eine Einwilligung erforderlich ist, andernfalls Art. 6 Abs. 1 lit. b oder
        f DSGVO, je nach Sachlage.
      </Typography>

      <Typography variant="h6" fontWeight={600}>
        3.4 Zahlungen und sonstige Drittinhalte
      </Typography>
      <Typography variant="body1">
        Wenn Sie Zahlungs- oder Checkout-Funktionen nutzen, kann der jeweilige Zahlungsdienstleister eigene Cookies
        setzen oder auslesen oder ähnliche Technologien auf seinen Domains verwenden. Diese Verarbeitung richtet sich
        nach den Informationen des Anbieters. Wir binden Zahlungsabläufe nur ein, soweit dies zur Abwicklung Ihrer
        Transaktion erforderlich ist.
      </Typography>

      <Divider />

      <Typography variant="h5" fontWeight={600}>
        4. Speicherdauer
      </Typography>
      <Typography variant="body1">
        Sitzungsbezogene Authentifizierungs-Cookies enden in der Regel, wenn Sie sich abmelden oder nach einer von
        unserem Authentifizierungsanbieter vorgegebenen sicherheitsrelevanten Speicherdauer. Bestehende dauerhafte
        Cookies oder gespeicherte Präferenzen können bestehen bleiben, bis sie ablaufen, Sie sie löschen oder Sie eine
        erteilte Einwilligung widerrufen. Konkrete Laufzeiten können je nach Browser und Konfiguration variieren.
      </Typography>

      <Divider />

      <Typography variant="h5" fontWeight={600}>
        5. Steuerungsmöglichkeiten
      </Typography>
      <Typography variant="body1" component="div">
        <ul>
          <li>
            Sie können in Ihren Browsereinstellungen Cookies blockieren oder löschen. Bitte beachten Sie, dass das
            Blockieren technisch notwendiger Cookies die Anmeldung oder Kernfunktionen beeinträchtigen kann.
          </li>
          <li>
            Soweit wir in der Anwendung Einstellmöglichkeiten für optionale Kategorien anbieten, können Sie dort Ihre
            Auswahl anpassen. Eine etwaige zukünftige Einwilligungsabfrage wird eine klare Möglichkeit bieten, nicht
            notwendige Cookies gemäß EU-Vorgaben zu akzeptieren oder abzulehnen.
          </li>
          <li>
            Eine erteilte Einwilligung können Sie jederzeit mit Wirkung für die Zukunft widerrufen, ohne dass die
            Rechtmäßigkeit der aufgrund der Einwilligung bis zum Widerruf erfolgten Verarbeitung berührt wird.
          </li>
        </ul>
      </Typography>

      <Divider />

      <Typography variant="h5" fontWeight={600}>
        6. Ihre Rechte und die Aufsichtsbehörde
      </Typography>
      <Typography variant="body1">
        Ihnen stehen die in der DSGVO vorgesehenen Rechte zu (u. a. Auskunft, Berichtigung, Löschung, Einschränkung der
        Verarbeitung, Widerspruch soweit anwendbar sowie unter bestimmten Voraussetzungen Datenübertragbarkeit). Sie
        haben zudem das Recht, sich bei einer Aufsichtsbehörde zu beschweren, insbesondere in dem Mitgliedstaat Ihres
        gewöhnlichen Aufenthaltsorts, Ihres Arbeitsplatzes oder des Orts des mutmaßlichen Verstoßes.
      </Typography>
      <Typography variant="body1">
        Einzelheiten und Kontaktmöglichkeiten finden Sie in Abschnitt 14 unserer{' '}
        <Link href="/legal/privacy?lang=de" color="primary">
          Datenschutzerklärung
        </Link>
        .
      </Typography>

      <Divider />

      <Typography variant="h5" fontWeight={600}>
        7. Änderungen
      </Typography>
      <Typography variant="body1">
        Wir können diese Cookie-Richtlinie anpassen, wenn sich unser Einsatz von Cookies oder ähnlichen Technologien
        ändert oder sich Rechtslage und behördliche Hinweise weiterentwickeln. Das Datum &quot;Stand&quot; oben wird
        entsprechend aktualisiert. Wesentliche Änderungen werden gegebenenfalls auch in der Datenschutzerklärung oder
        innerhalb der Anwendung kenntlich gemacht.
      </Typography>
    </Stack>
  );
}
